var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-1182 -339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 25,
    height: 25,
    transform: "translate(1182 339)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file_2_",
    "data-name": "file (2)",
    transform: "translate(1120 341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M82.278,6.42a.485.485,0,0,0-.111-.166l-6.1-6.1A.527.527,0,0,0,75.9.039.513.513,0,0,0,75.7,0H65.526A1.528,1.528,0,0,0,64,1.526V22.9a1.528,1.528,0,0,0,1.526,1.526H80.79A1.528,1.528,0,0,0,82.317,22.9V6.614A.513.513,0,0,0,82.278,6.42ZM76.72,6.106a.51.51,0,0,1-.509-.509V1.737L80.58,6.106Z",
    transform: "translate(-64)",
    fill: "#3f2765"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 14,
    height: 7,
    transform: "translate(1186 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Test",
    transform: "translate(1187 357)",
    fill: "#3f2765",
    fontSize: 5,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Test")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestType);
export default __webpack_public_path__ + "static/media/test_type.4135526c0ca177f30461716fd6c0f53e.svg";
export { ForwardRef as ReactComponent };